export default "__VITE_ASSET__qwGcb4zI__"